var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/IconAwardStar.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var IconAwardStar = function IconAwardStar(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    viewBox: "20 25 105 105",
    fill: "none",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100",
    height: "100",
    fill: "none",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.16 56.4l-.08 70.32 16.09-17.25 17.34 17.7.09-70.32-33.44-.45z",
    fill: "#f2a619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.81 31.79a32.24 32.24 0 0 0-29.819 19.861 32.24 32.24 0 0 0 6.943 35.148 32.24 32.24 0 0 0 35.131 7.03c5.895-2.434 10.935-6.562 14.484-11.861S109.994 70.437 110 64.06a32.23 32.23 0 0 0-2.438-12.337c-1.615-3.912-3.985-7.468-6.974-10.465s-6.539-5.375-10.447-7A32.23 32.23 0 0 0 77.81 31.79z",
    fill: "#ffd237",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.12 46.28l4.8 9.73 10.74 1.56-7.77 7.58 1.84 10.69-9.61-5.05-9.6 5.05 1.83-10.69-7.77-7.58 10.74-1.56 4.8-9.73z",
    fill: "#fff",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }));
};

IconAwardStar.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
IconAwardStar.defaultProps = {
  className: null
};
export default IconAwardStar;